module.exports = __webpack_public_path__ + "media/story-streak.6c43821b.mp3";